import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

export default function useRemoveProductDocumentPropertyTemplate() {
    return useMutation(async ({ documentId, entityId }: { documentId: number; entityId: number }) => {
        return trpc.ProductsApi.removeProductDocumentTemplateProperty.mutate({
            id: documentId,
            entityId,
        });
    });
}
